import React from "react";
import { Color } from "../../theme/Color";
import { BigYellowLinkButton, Description, Section80, SubTitle, TitleSection } from "../DesignComponent/DesignComponents";

const CustomReports = ({ title, desc, btn, btnlink, img, smalltitle }) => {
  return (
    <>
      <Section80
        className="movefaster-sec text-center text-white"
        style={{ backgroundColor: Color.theme_secound }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-2 d-lg-block d-none"></div>
            <div className="col-lg-8">
              <SubTitle className="sub-title mb-2">{smalltitle}</SubTitle>
              <TitleSection className="mb-3">{title}</TitleSection>
              <Description className="description mb-4">{desc}</Description>
              <BigYellowLinkButton to={btnlink} className="">{btn}</BigYellowLinkButton>
              <img src={img} alt={title} className="w-100 mt-md-5 mt-0 pt-4" />
            </div>
            <div className="col-lg-2 d-lg-block d-none"></div>
          </div>
        </div>
      </Section80>
    </>
  );
};
export default CustomReports;
